import { combineReducers } from "@reduxjs/toolkit";
import storage from "redux-persist/lib/storage";
import { persistReducer } from "redux-persist";
import { authSlice } from "../redux/authSlice";
import { paymentSlice } from "../redux/paymentSlice";
import { usersTableReducer } from "../redux/usersTableSlice";
import { dashboardReducer } from "../redux/dashboardSlice";

const authPersistConfig = {
	key: "auth",
	storage,
	blacklist: ["token"],
};

export const rootReducers = combineReducers({
	auth: persistReducer(authPersistConfig, authSlice.reducer),
	paymentInsertion: paymentSlice.reducer,
	userTable: usersTableReducer,
	dashboard: dashboardReducer,
});